import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import type { RouteComponentProps } from 'react-router';

import ProjectGroupsModule from '../../../redux/project_grouping';
import Loader from '../../generic/Loader';
import type { ProjectGroup, ProjectGroupRelease } from '../../../types';

import ProjectGroupReleaseProjectsTable from './components/ProjectGroupReleaseProjectsTable';
import ProjectGroupReleaseProjectsTableHeader from './components/ProjectGroupReleaseProjectsTableHeader';

type DispatchProps = {
  fetchRelease(projectGroupId: number, id: number): Promise<void>;
};

type ProjectGroupProjectsTabProps = {
  release: ProjectGroupRelease;
  selectedRelease: ProjectGroupRelease;
  projectGroup: ProjectGroup;
  releaseProjectsLoading: boolean;
} & RouteComponentProps<Params, {}> & DispatchProps;

type Params = {
  projectGroupId: number;
}

class ProjectGroupProjectsTab extends Component<ProjectGroupProjectsTabProps, {}> {
  componentDidMount() {
    if (this.props.selectedRelease) {
      return this.fetchRelease(this.props.selectedRelease);
    }
    return this.fetchRelease(this.props.projectGroup.releases[0]);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedRelease?.id !== this.props.selectedRelease?.id) {
      this.fetchRelease(this.props.selectedRelease);
    }
  }

  async fetchRelease(release) {
    await this.props.fetchRelease(this.props.params.projectGroupId, release.id);
  }

  render() {
    const groupId = this.props.projectGroup && this.props.projectGroup.id;
    if (this.props.releaseProjectsLoading) return <Loader />;
    return (
      <div className="container project-group-projects-page-body">
        <div className="select-projects">
          <ProjectGroupReleaseProjectsTableHeader
            releaseProjects={this.props.release?.projects ?? []}
            editProjects
            showSelectProjects={false}
            onShowSelectProjects={null}
            projectGroupId={groupId || null}
            selectedRelease={this.props.selectedRelease || this.props.release}
          />
          <ProjectGroupReleaseProjectsTable
            releaseProjects={this.props.release?.projects ?? []}
            sortableBranchCommit
            readOnly
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  release: ProjectGroupsModule.selectors.getRelease,
  selectedRelease: ProjectGroupsModule.selectors.getSelectedRelease,
  projectGroup: ProjectGroupsModule.selectors.getCurrentProjectGroup,
  releaseProjectsLoading: ProjectGroupsModule.selectors.getReleaseIsLoading,
});

const mapDispatchToProps = {
  fetchRelease: ProjectGroupsModule.actions.fetchRelease,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectGroupProjectsTab);
